import { render } from "./ModuleSkillsAuditSkillGap.vue?vue&type=template&id=85fc6744&scoped=true"
import script from "./ModuleSkillsAuditSkillGap.vue?vue&type=script&lang=js"
export * from "./ModuleSkillsAuditSkillGap.vue?vue&type=script&lang=js"

import "./ModuleSkillsAuditSkillGap.vue?vue&type=style&index=0&id=85fc6744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85fc6744"]])

export default __exports__